import React from 'react';
import {
    Modal,
    TextStyle,
    IndexTable,
    Link
} from '@shopify/polaris';
import Cookies from "js-cookie";

class ShowTagGroupErrorsModal extends React.Component {

    state = {
        errors: [],
    };

    render() {

        const resourceName = {
            singular: 'customer',
            plural: 'customers',
        };
        const shopOrigin = Cookies.get("shopOrigin");

        const rowMarkup = this.props.errors.map(
            ({ title, error, legacyId, resourceType, resourceId }, index) => {

                let link = `https://${shopOrigin}/admin/customers/${legacyId}`;

                if (resourceType === "Product") {
                    link = `https://${shopOrigin}/admin/products/${legacyId}`;
                }

                const markup = (
                    <IndexTable.Row id={resourceId} key={resourceId} position={index}>
                        <IndexTable.Cell>
                            <Link url={link}><TextStyle variation="strong">{title}</TextStyle></Link>
                        </IndexTable.Cell>
                        <IndexTable.Cell>{resourceType}</IndexTable.Cell>
                        <IndexTable.Cell>{error}</IndexTable.Cell>
                    </IndexTable.Row>
                );

                return markup;
            },
        );

        return <Modal sectioned
            large={true}
            open={this.props.active}
            onClose={this.props.onDismiss}
            title="Validation Errors"
            secondaryActions={[{
                content: 'Close',
                onAction: this.props.onDismiss,
            }]}
        >
            <IndexTable
                resourceName={resourceName}
                itemCount={this.props.errors.length}
                headings={[
                    { title: 'Name' },
                    { title: 'Type' },
                    { title: 'Error' },
                ]}
                selectable={false}
            >
                {rowMarkup}
            </IndexTable>
        </Modal>
    }

    componentDidMount() {
    }
}

export default ShowTagGroupErrorsModal;